
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertTriangle, Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface StopActionProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

export function StopAction({ value, onChange }: StopActionProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between space-x-2">
        <div className="flex items-center gap-1">
          <Label htmlFor="stop-processing" className="text-base">Stop processing further rules</Label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Info className="h-4 w-4 text-muted-foreground cursor-help" />
              </TooltipTrigger>
              <TooltipContent side="right" align="start" className="max-w-xs">
                <p className="text-sm">
                  When enabled, this rule will be the final rule applied to matching emails.
                  Any rules below this one in the rule order will be skipped.
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Switch
          id="stop-processing"
          checked={value}
          onCheckedChange={onChange}
        />
      </div>
      
      {value && (
        <Alert className="bg-amber-50 border-amber-200">
          <AlertTriangle className="h-4 w-4 text-amber-500" />
          <AlertDescription>
            Any rules below this one in the rule order will be ignored for emails that match this rule
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
}
